// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2b4tf","title":"Header_title__2FLmQ","left":"Header_left__1_kBi","clinicName":"Header_clinicName__33qX4"};